export default __webpack_public_path__ + "static/media/leaf.ecd6f337.svg";